/**
 * Shared guard for the reference expanders (mentions, card refs, wiki
 * refs): tokens already sitting inside markdown link syntax must not be
 * expanded again — doing so nests anchors and renders doubled links.
 */

/** True when the token at `offset` is inside `[label](target)` syntax. */
export function insideMarkdownLink(text: string, offset: number): boolean {
  // Inside the (target): an unclosed "](" before us on the same stretch
  const before = text.slice(0, offset);
  const lastParenOpen = before.lastIndexOf('](');
  if (lastParenOpen !== -1) {
    const afterParen = before.slice(lastParenOpen + 2);
    if (!afterParen.includes(')')) return true;
  }
  // Inside the [label]: an unclosed "[" before us whose "]" (followed by
  // "(") comes after us
  const lastBracket = before.lastIndexOf('[');
  if (lastBracket !== -1 && !before.slice(lastBracket).includes(']')) {
    const close = text.indexOf(']', offset);
    if (close !== -1 && text[close + 1] === '(') return true;
  }
  return false;
}
